/**
 * @created on 2017/9/19
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import { getRunTime } from '../../../public-resource/libs/utils/index'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
let YIAPI_HOST = getRunTime('//yiapi.xinli001.com')
let IS_APP = window.$platform.isYixinliApp
let protocol = window.location.protocol

module.exports = {
  host: protocol + HOST,
  isLogin: `${HOST}/ajax/get-user-header`,
  getWXShareConfig: `${HOST}/wx/get-wx-package.json`,
  getRewardQaData: `${HOST}/qa/get-reward-question-list`, // 数据获取
  login: IS_APP
    ? 'yixinli://open_user_login'
    : `${HOST}/account/login?next=${encodeURIComponent(
        protocol + HOST + location.pathname + location.search + location.hash
      )}`,
  sameFeel: `${HOST}/qa/qa-same-feeling-toggle.json`, // 同感接口
  storeQuestion: `${HOST}/qa/store-question.json` // 关注问题
}



// WEBPACK FOOTER //
// ./src/pages/ask/rewardArea/api.js